import { Badge } from '@/components/ui/badge';
import type { EventStatus } from '@/types/events';
import { EVENT_STATUS_LABELS } from '@/types/events';

interface EventStatusBadgeProps {
  status: EventStatus;
}

export function EventStatusBadge({ status }: EventStatusBadgeProps) {
  const variants: Record<EventStatus, 'default' | 'secondary' | 'destructive' | 'outline'> = {
    draft: 'outline',
    public: 'default',
    cancelled: 'destructive',
  };
  
  return (
    <Badge variant={variants[status]}>
      {EVENT_STATUS_LABELS[status]}
    </Badge>
  );
}
